module.exports = __webpack_public_path__ + "img/lasource-31.5992573f.jpg";